export default "__VITE_ASSET__CBcQG07l__"